import React from "react"

import { AppAntSwitch } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportGenerateSwitch() {
	const {
		generate,
		setGenerateInfo,
	} = useReportFormInfo(reportFormData.peek().generate, "generate", object({ generate: boolean() }))

	return <AppAntSwitch
		trueText="Generate"
		checked={!!generate}
		onChange={e => setGenerateInfo(e.target.checked)}
	/>
}